"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderCustomerStatus = void 0;
const React = require("react");
const moment = require("moment-timezone");
const TSalesOrderType_1 = require("../../../types/TSalesOrderType");
const standardSizes_1 = require("../../../../../../types/standardSizes");
const CircularIcon_1 = require("../../../../../../components/base/atoms/CircularIcon");
const react_router_dom_1 = require("react-router-dom");
const retailOrderingRoutes_1 = require("../../../../../../apps/spg/ordering/components/RetailOrderingApp/retailOrderingRoutes");
const useSalesOrderDetailsForStatus_1 = require("../../../hooks/useSalesOrderDetailsForStatus");
const useSalesOrderDetailsForCurrentTime_1 = require("../../../hooks/useSalesOrderDetailsForCurrentTime");
const constants_1 = require("../../../../../../helpers/constants");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "SalesOrderCustomerStatus");
const SalesOrderCustomerStatus = ({ salesOrder }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { predictedCompletionTimeFormatted, completed, type, deliveryDriver, retailLocation: { timezone: { timeZoneId } } } = salesOrder;
    const dropoffTime = deliveryDriver === null || deliveryDriver === void 0 ? void 0 : deliveryDriver.dropoffTime;
    const { statusBackgroundImage, statusText } = (0, useSalesOrderDetailsForStatus_1.useSalesOrderDetailsForStatus)(salesOrder);
    const { isSameOperationalDay } = (0, useSalesOrderDetailsForCurrentTime_1.useSalesOrderDetailsForCurrentTime)(salesOrder);
    const estimatedCompletionTime = dropoffTime
        ? moment(dropoffTime)
            .tz(timeZoneId) // if not the same operational day add in the date
            .format(isSameOperationalDay ? constants_1.humanTimeFormat : constants_1.humanDateTimeFormat)
        : predictedCompletionTimeFormatted;
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("background"), style: { backgroundImage: `url("${statusBackgroundImage}")` } }),
        React.createElement(CircularIcon_1.CircularIcon, { className: css("backBtn"), name: "chevron-left", size: standardSizes_1.TStandardSizes.Small, onClick: completed || history.location.state === retailOrderingRoutes_1.retailOrderingPaths.cart
                ? () => history.push(retailOrderingRoutes_1.retailOrderingPaths.restaurant)
                : history.goBack }),
        React.createElement("div", { className: css("status") },
            completed === false && (React.createElement("div", { className: css("status_estimation") },
                React.createElement("span", { className: css("status_estimation_time") }, estimatedCompletionTime),
                React.createElement("span", { className: css("status_estimation_label") }, type === TSalesOrderType_1.TSalesOrderType.Delivery
                    ? "Estimated arrival"
                    : "Estimated pickup"))),
            React.createElement("div", { className: css("status_text") }, statusText))));
};
exports.SalesOrderCustomerStatus = SalesOrderCustomerStatus;
//# sourceMappingURL=index.js.map